// FI-1935: who an ERM event can be assigned to, as the pickers see it.
//
// /bookings/users/list returns every users row on the tenant, including the
// shadow rows the public form creates for outside submitters and roles that
// never open the ops desk (drivers, garage, wash bay, booking customers).
// the server refuses shadow rows outright; the role cut here is presentation
// only, so a stale assignee outside this set still renders by name.
const NEVER_ASSIGNABLE_ROLES = new Set(['driver', 'other', 'garage', 'wash-bay', 'booking-customer'])
const SHADOW_DOMAIN = '@ops-desk.fleetintegrations.com'

export function isAssignable(user) {
  if (!user) return false
  const username = String(user.username || '').trim()
  if (!username) return false
  if (username.startsWith('shadow:') || username.toLowerCase().endsWith(SHADOW_DOMAIN)) return false
  if (user.shadow === true || user.claim_status === 'unclaimed') return false
  if (NEVER_ASSIGNABLE_ROLES.has(String(user.role || '').toLowerCase())) return false
  return true
}

export function assignableUsers(users) {
  return (users || []).filter(isAssignable)
}

// roles the api lets read the full user directory (/bookings/users/list);
// mirrors tenant_directory_user_required in fleet-int-api util/cm_security.py.
// everyone else on the ops desk (staff, dispatch) reads the lighter
// /bookings/users/contacts/list instead, so no picker ever 403s, which the
// networking layer would turn into a logout.
export const DIRECTORY_ROLES = new Set(['admin', 'customer-admin', 'manager'])

export function canReadDirectory(user) {
  return !!user && DIRECTORY_ROLES.has(String(user.role || '').toLowerCase())
}
